import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_URL } from '@frontend-site/shared/data';
import { Observable } from 'rxjs';

/**
 * Changes the logged-in user's password via the backend's IDP delegation endpoint
 * (`POST /UM/password/change`). Separate from `UserService.changeProfile` so admin
 * reset-with-mail stays on its own legacy path.
 */
@Injectable({ providedIn: 'root' })
export class ChangePasswordService {
    constructor(private readonly http: HttpClient, @Inject(API_URL) private readonly apiUrl: string) {}

    change(currentPassword: string, newPassword: string): Observable<void> {
        return this.http.post<void>(`${this.apiUrl}/UM/password/change`, { currentPassword, newPassword });
    }
}
